module.exports = __webpack_public_path__ + "resource/img/paper.c34cc8f7.svg";